import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { Button } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import { useSmartSearchStore } from '~/store/common';

import { SMART_SEARCH_MENU_PATHS } from '~/constants';

import { AiStarsGradientIcon } from '../Icon';

import styles from './SmartSearchButton.module.scss';

const SmartSearchButton = () => {
  const { pathname } = useLocation();

  const mode = useSmartSearchStore((state) => state.mode);
  const { setMode, resetStore } = useSmartSearchStore((state) => state.actions);

  const isSmartSearchMenu = SMART_SEARCH_MENU_PATHS.some((path) => pathname.startsWith(path));
  const isActive = mode !== 'closed';

  useEffect(() => {
    if (!isSmartSearchMenu && isActive) {
      resetStore();
    }
  }, [isSmartSearchMenu]);

  if (!isSmartSearchMenu) return null;

  const handleClick = () => {
    if (isActive) {
      resetStore();
    } else {
      setMode('docked');
    }
  };

  return (
    <Button
      className={clsx(styles['smart-search-button'], isActive && styles['active'])}
      variant="outlined"
      color="tertiary"
      size="tiny"
      leftIcon={<AiStarsGradientIcon size={16} />}
      onClick={handleClick}
    >
      스마트 문의하기
    </Button>
  );
};

export default SmartSearchButton;
